import { set as setStorage} from "../storage/localStorage";

export const createLoqateFields = (loqateState) => {
    const loqateField :any = {};
    if(Object.keys(loqateState).length) {
        loqateField.suggestedShippingAddress = loqateState.suggestedShippingAddress;
        loqateField.suggestedBillingAddress = loqateState.suggestedBillingAddress;
        loqateField.shippingAddressType = loqateState.shippingAddressType;
        loqateField.billingAddressType = loqateState.billingAddressType;
    }
    return loqateField;
}

export const saveGuestAddressFormInStorage = (shippingData, billingData, loqateState={}) =>{
    const addressObj: any = Object();
    addressObj['shipping'] = shippingData;
    addressObj['billing'] = billingData;
    addressObj.loqateInfo = createLoqateFields(loqateState);
    setStorage('cartAddress', addressObj)
}
